import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import { FeatureLabel3D } from '../procedural/FeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from '../procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from '../procedural/SurfaceMeshFeature3D'
import { useSurfaceProps } from '@asset-viz/objects/surfaces/util/SurfaceProvider'
import React from 'react'
import {
  GeckoComponentCoords,
  GeckoComponentPolygon,
  GeckoShipDeckBulkhead,
} from 'types'
/**
 * @param model
 * @constructor
 */

export const DeckBulkheadFeature3D: React.FC<{
  model: GeckoShipDeckBulkhead
}> = ({ model }) => {
  const { bounds, wrapMode } = useSurfaceProps()
  const { weldColorString } = useAssetVizInternal()
  const coords = model.coordinates

  const xCoords = coords.map((point) => point.x.num)
  const yCoords = coords.map((point) => point.y.num)
  const minX = Math.min(...xCoords)
  const maxX = Math.max(...xCoords)
  const minY = Math.min(...yCoords)
  const maxY = Math.max(...yCoords)

  const centerX = (minX + maxX) / 2
  const centerY = (minY + maxY) / 2

  const firstPoint = coords[0]
  const centerGeometry = GeckoComponentCoords.CreateFromValues(
    bounds.componentID,
    centerX,
    firstPoint.x.unit,
    centerY,
    firstPoint.y.unit
  )

  const boundingPath = React.useMemo(
    () =>
      GeckoComponentPolygon.CreateFromPolygonalPlate(
        model.coordinates,
        bounds,
        wrapMode
      ),
    [bounds, model.coordinates, wrapMode]
  )

  return (
    <>
      <FeatureLabel3D
        feature={model}
        coords={centerGeometry}
        anchor={'center'}
      />
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        colorMesh={true}
        fillColor={weldColorString}
      />
    </>
  )
}
